import { useRecordView } from '../../hooks/useRecordView';

const ViewRecorder = () => {
  useRecordView();
  return null;
};

export default ViewRecorder;
